import React, { useContext, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
// import { Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import ApiAccount from "../../../core/api/api.account";
import ContextApp from "../../../core/contexts/context.app";
// import useLoginModal from '../../../core/hooks/useLoginModal';
import { PatternFormat } from "react-number-format";
import { toast, ToastContainer } from "react-toastify";
import _ from "lodash";
import { IconArrowRight } from "../../../assets/icons";
import LoadingDottedButton from "../../components/LoadingDottedButton";

function Refund({ showRefundModal, setShowRefundModal, onAddAccount }) {
  //const { register, handleSubmit, control, setValue, formState: { errors }, reset } = useForm({ defaultValues: { accountNumber: "1234567890", ss: 3 } });
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm();
  const ctx = useContext(ContextApp);
  // const [Modali, setShow] = useLoginModal();

  useEffect(() => {
    if (ctx.isAuth) {
      // setTimeout(() => reset({ ss: 4, accountNumber:"1234567899" }), 2000);
      // اگر قرار است دیتای اولیه ای از سرور بیاورد اینجا به صورت بالا استفاده میکنیم
    } else {
    }
  }, [ctx.isAuth]);
  const handleClose = () => {
    setShowRefundModal(false);
  };
  const onSubmit = async (data) => {
    try {
      data.accountOwnerName = data.cardOwnerName;
      data.cardNumber = data.cardNumber.split(" ").join("").split("-").join("");
      const response = await ApiAccount.createAccount(data);

      if (
        !_.isEmpty(response) &&
        response.data !== undefined &&
        response.data > 0
      ) {
        onAddAccount({
          title:
            "شماره کارت " + data.cardNumber + " به نام: " + data.cardOwnerName,
          value: response.data + "",
        });
        //reset({}); //کار نمیکند
      }
    } catch (error) {}
  };
  const ff = {
    bank: register("bank", { required: true }),
    accountNumber: register("accountNumber", {
      maxLength: 24,
    }),
    cardOwnerName: register("cardOwnerName", { required: true }),
    cardNumber: register("cardNumber", {
      required: true,
      maxLength: 25,
      minLength: 25,
    }),
    shebaNumber: register("shebaNumber", {
      required: true,
      maxLength: 24,
      minLength: 24,
    }),
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Modal show={showRefundModal} onHide={handleClose}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header onClick={handleClose}>
            <IconArrowRight fillColor="#000" />
            درج اطلاعات حساب{" "}
          </Modal.Header>

          <Modal.Body>
            {/* <ToastContainer position="top-center" rtl="true"></ToastContainer> */}
            <div className="text-black-06 fs-09 mb-2 text-center">
              لطفا فرم زیر را کامل نمایید.{" "}
            </div>

            <Form.Control
              {...ff.bank}
              type="text"
              className="mb-2  text-center"
              placeholder="نام بانک"
              maxLength={"24"}
            />
            {errors.bank && (
              <div className="text-danger text-center fs-085 mb-3">
                نام بانک نمیتواند خالی باشد
              </div>
            )}
            <Form.Control
              {...ff.accountNumber}
              type="number"
              className="mb-2 ltr text-center"
              placeholder="شماره حساب"
              onKeyPress={(e) => {
                if (e.target.value.length === 24) {
                  e.preventDefault();
                }
              }}
            />
            {errors.accountNumber?.type === "maxLength" && (
              <div className="text-danger text-center fs-085 mb-3">
                شماره حساب باید 24 رقم باشد
              </div>
            )}
            <Form.Control
              {...ff.cardOwnerName}
              type="text"
              className="mb-2  text-center"
              placeholder="نام صاحب کارت"
            />
            {errors.cardOwnerName && (
              <div className="text-danger text-center fs-085 mb-3">
                نام صاحب کارت نمیتواند خالی باشد
              </div>
            )}
            <Controller
              name="cardNumber"
              control={control}
              rules={{
                required: true,
                maxLength: 25,
                minLength: 25,
              }}
              render={({ field: { onChange, value } }) => (
                <PatternFormat
                  format="#### - #### - #### - ####"
                  mask=""
                  type="text"
                  name="cardNumber"
                  className="form-control mb-2 ltr  text-center"
                  placeholder="شماره کارت"
                  value={value || ""}
                  onChange={onChange}
                />
              )}
            />
            {/* <NumberFormat className="form-control mb-2 ltr" format="#### - #### - #### - ####" mask=""
                            {...ff.cardNumber}
                            placeholder="شماره کارت"
                        /> */}
            {errors.cardNumber?.type === "required" && (
              <div className="text-danger text-center fs-085 mb-3">
                شماره کارت نمیتواند خالی باشد
              </div>
            )}
            {errors.cardNumber?.type === "minLength" && (
              <div className="text-danger text-center fs-085 mb-3">
                شماره کارت باید 16 رقم باشد
              </div>
            )}
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  {...ff.shebaNumber}
                  onKeyPress={(e) => {
                    if (e.target.value.length === 24) {
                      e.preventDefault();
                    }
                  }}
                  type="number"
                  className="mb-2 ltr text-center border-end-0 rounded-end-0"
                  placeholder="شماره شبا"
                />
                <Form.Control
                  style={{ width: "25px" }}
                  disabled
                  className="form-control border-start-0 text-black mb-2 bg-white mb-2 rounded-start-0 ps-0 pe-1"
                  value="-IR"
                />
              </div>

              {errors.shebaNumber?.type === "required" && (
                <div className="text-danger text-center fs-085 mb-3">
                  شماره شبا نمیتواند خالی باشد
                </div>
              )}
              {errors.shebaNumber?.type === "minLength" && (
                <div className="text-danger text-center fs-085 mb-3">
                  شماره شبا باید 24 کاراکتر باشد
                </div>
              )}
            </Form.Group>
            {!isSubmitting ? (
              <button type="submit" className="btn btn-primary w-100 rounded-2">
                ذخیره
              </button>
            ) : (
              <button
                disabled
                type="submit"
                className="btn btn-primary w-100 rounded-2"
              >
                <LoadingDottedButton btnText="ذخیره" />
              </button>
            )}
            {/* <Button
              variant="primary"
              type="submit"
              disabled={isSubmitting}
              className="w-100 rounded-2"
            >
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              ذخیره
            </Button> */}
            <Link
              to="/wallet"
              className="btn btn-outline-primary w-100 rounded-2 mt-2 mb-5"
            >
              بازگشت به صفحه قبل
            </Link>
          </Modal.Body>
        </form>
      </Modal>
    </>
  );
}
export default Refund;
